import { useContext } from "react";
import { useParams } from "react-router-dom";
import SimulationContext from "./contexts/Simulation";
import Logo from "./components/Logo";
import Helper from "./components/Helper";

const SimWrapper = ({ step, children, Tabs }) => {
  const [simParams] = useContext(SimulationContext);
  const routeParams = useParams();
  const isResultRecord = !!routeParams.ruid;

  const begin = step === 'begin';
  return (
    <div id={begin ? '' : 'stepper'} className={'simcontainer sc' + step}>
      { isResultRecord ?
      <div className="simheader resultrecord">
        <a href="/">
          <Logo color='black' width={238} height={55}/>
        </a>
        <div class="message">
          Cette simulation est figée à partir des informations que vous avez saisies. Vous pouvez <a href="/simulateur">lancer une nouvelle simulation</a> à tout moment si vos données évoluent ou prendre rdv pour une étude encore plus personnalisée.
        </div>
      </div> :
      <div className="simheader">
        <a href="/">
          <Logo color={begin ? 'white' : 'black'} size='small' width={50} height={44}/>
        </a>
        { !!Tabs && <Tabs/> }
        <Helper step={step} start={simParams.video_play}/>
      </div> }
      { children }
    </div>
  )
};

export default SimWrapper;